module.exports = __webpack_public_path__ + "static/media/webhook2.a8c65593.png";